import React, { useEffect,  useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';
import { PRCDropDown } from '../controls/prcdropdown.js';

export function ReportMemberVisitsForm() {


    const [pageData, setPageData] = useState();
   const [reportData, setReportData] = useState([]);
    const [yearData, setYearData] = useState([]);
    const[currentYear, setCurrentYear] = useState();
    const[currentVisitCount, setCurrentVisitCount] = useState(5);
    const[memberCount, setMemberCount] = useState(0);
    const navigate = useNavigate();
    
    let first_render = useRef(true);

    const { MakeCall } = useAPICall();



    useEffect(() => {
        MakeCall('admin/getyearspage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleYearDataFetch);
        //MakeCall('reports/getcurrentroreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    });


    const handleYearDataFetch = (data) => {        
        
        let years = [];
        for (let i = 0; i < data.components['years'].length; i++) {
            let year = data.components['years'][i];
            if (new Date(year.peveril_year_end).getFullYear() === 2001) {               
                setCurrentYear(year.idpeveril_year);
            }
            years.unshift({id:year.idpeveril_year, description: year.peveril_year_name});
        }
        setYearData(years);

    }

    const handleReportDataFetch = (data) => {        
        
       setReportData(data.components['report_data']);
       setMemberCount(data.components['member_count']);
    }
  
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

   function handleGenerateReport()
   {
      MakeCall('reports/getmembervisitreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + 
         "\", \"numberofvisits\" : \"" + currentVisitCount +
         "\", \"idpeveril_year\" : \"" + currentYear +
         "\"}", handleReportDataFetch, true);
   }

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/AdminReports");
                break;
           
            default:
                break;
        }
    }
    function handleVisitChange(visits) {
        setCurrentVisitCount(visits);
        
       // sessionStorage.setItem("visits", visits);
    }
    function handleYearChange(year) {
        setCurrentYear(year);
        
        
    }

    function handleShowMember(id) {
        navigate("/ViewMember", { state: { memberID: id } });
    }
    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Member Visit Report</div>
                    <div className='formrow' key='description' style={{"paddingBottom":"25px"}}>
                       This report shows visit counts for Individual and Family member types. Lifetime, Probationers and Overseas are excluded.                                        
                    </div>                    
                    <div className='formrow' key='visits' style={{"paddingBottom":"25px"}}>
                        <div className='gridcell'>
                         <PRCDropDown  id='visitcount' className='logininput' name='VISIT_COUNT' placeholder="Max Visit Count" options={[{id: 0, description: "0 visits"}, 
                        {id: 1, description: "1 or fewer visits"}, 
                        {id: 2, description: "2 or fewer visits"}, 
                        {id: 3, description: "3 or fewer visits"}, 
                        {id: 4, description: "4 or fewer visits"}, 
                        {id: 5, description: "5 or fewer visits"}, 
                        {id: 6, description: "All"}]} value={currentVisitCount} onChange={handleVisitChange} />
                        </div>
                        <div className='gridcell'>
                        <PRCDropDown id='membershipyear' className='logininput' name='YEAR' placeholder="Year" options={yearData} value={currentYear}  onChange={handleYearChange} />
                        </div>
                    </div>
                    <div className='formrow' key='generate' style={{"paddingBottom":"25px"}}>
                        <button type="button" className='prcbtn' onClick={handleGenerateReport}>Generate</button>
                    </div>
                    {<div>Member Count : {memberCount}</div>}
                    <div className='gridrow' key="headers" style={{"paddingTop" : "10px", "paddingBottom" : "10px", "fontWeight" : "bold"}}>

                    <div className='gridcell' style={{"justifyContent" : "left", "width":"15%"}}>Mem #</div>   
                    <div className='gridcell' style={{"justifyContent" : "left", "width":"50%"}}>Name</div>                       
                    <div className='gridcell' style={{"justifyContent" : "left", "width":"20%"}}>Visits</div>   
                    <div className='gridcell' style={{"justifyContent" : "left", "width":"100%"}}>Email</div>   
                    </div>
                    {reportData.map((member) => (

                            <div className='gridrow' key={member.idpeveril_member} style={{"paddingTop" : "10px", "paddingBottom" : "10px"}} onClick={() => { handleShowMember(member.idpeveril_member) }} id={member.idpeveril_member}>                                                            
                                <div className='gridcell' style={{"justifyContent" : "left", "width":"15%"}}>{member.membership_number}</div>   
                                <div className='gridcell' style={{"justifyContent" : "left", "width":"50%"}}>{member.forename + " " + member.surname}</div>                                                                                                                                                                                                                                            
                                <div className='gridcell' style={{"justifyContent" : "left", "width":"20%"}}>{member.visits}</div>   
                                <div className='gridcell' style={{"justifyContent" : "left", "width":"100%"}}>{member.email}</div>                                 
                            </div>                                
                                          
                        ))}
                    
                </div>

           
            </div>
        </div>


    );
}
